// DocumentComponent.jsx
import React, { useEffect, useState } from "react";
import { Document, Page, Text, View, StyleSheet, PDFDownloadLink, Image, Font } from "@react-pdf/renderer";
import sitlogo from "../assets/images/sitlogo.png";
import { BASE_URL } from "./BaseUrl";

import axios from "axios";
// Create styles
const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        fontFamily: "Helvetica",
        color: "lightslategrey",
        border: "1px solid black",
        borderColor: "black",
        borderWidth: 1,
        borderStyle: "solid round",
    },
    header: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        borderBottom: "2px solid #000",
        height:"4%",
        paddingBottom: 0,

        header1: {
            justifyContent:"center"
        },
    },
    headerLeft: {
        textAlign: "left",
        flex: "3",
    },
    image: {
        height: 80,
        width: 160,
    },
    

    billTo: {
        marginBottom: 15,
        fontSize: 12,
        fontWeight: "bold",
    },
    Course: {
        display: "flex",
        flexDirection: "row",
    },
    courseleft: {
        display: "flex",
        flexDirection: "row",
        flexDirection: "row",
        alignItems: "center",
        flex: "3",
    },
    courseright: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flex: "7",
    },
    coursecenter: {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        flex: "9",
    },
    itemsTable: {
        width: "100%",
        borderCollapse: "collapse",
        marginBottom: 20,
    },
    tableRow: {
        flexDirection: "row",
    },
    tableCellHeader: {
        fontWeight: "700",
        width: "50%",
        alignItems: "center",
        marginLeft: "200px",
    },
    tableCell: {
        width: "50%",
    },
    tableCol: {
        borderStyle: "solid",
        borderWidth: 1.5,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderCollapse: "collapse",
    },
    tableCol1: {
        borderStyle: "solid",
        borderWidth: 1.5,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderCollapse: "collapse",
    },
    tableCol10: {
        borderStyle: "solid",
        borderWidth: 1,
        borderBottomWidth: 1,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        borderCollapse: "collapse",
        display: "flex",
        flexDirection: "row",
    },
    tableCol2: {
        borderStyle: "solid",
        borderWidth: 1,
        // borderBottomWidth:0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        minHeight: 80,
    },
    totals: {
        marginBottom: 20,
    },
    footer1: {
        marginBottom: 10,
        margintop: 10,
    },
    footer: {
        marginBottom: 20,
        display: "flex",
        flexDirection: "row",
    },
    footer3: {
        position: "fixed",
        bottom: 0,
        display: "flex",
        flexDirection: "row",
    },
    footer4: {
        position: "fixed",
        top: 487,
        bottom: 0,
        display: "flex",
        flexDirection: "row",
    },
    signatory: {
        textAlign: "right",
        marginTop: 40,
    },
});
Font.register({
  family: 'Poppins',
  fonts: [
    { src: '/fonts/Poppins-Regular.ttf', fontWeight: 'normal' },
    { src: '/fonts/Poppins-SemiBold.ttf', fontWeight: 600 },
    { src: '/fonts/Poppins-Bold.ttf', fontWeight: 'bold' },
  ],
});

const MyDocument7 = ({ pdfdata }) => {
    console.log('thisiunisud',pdfdata);
    
    return (
        <Document>
            {pdfdata.map((item) => {
                // const parseHTML = (html) => {
                //     // This function can be expanded for more advanced parsing.
                //     return html.replace(/<\/?[^>]+(>|$)/g, ""); // Removes HTML tags for simple use cases
                // };

                return (
                    <Page size="A4" style={styles.page}>
                        <View style={{ border: "none" , paddingTop: 150}}>
                            <View style={styles.header}>
                                <View style={ {borderRight:"1.5px solid black",borderTop:"1.5px solid black", borderLeft:"1px solid black", width:"100%", height:"100%", justifyContent:"center", alignItems:"center"}}>
                                    <Text style={{ fontSize: "9.5px", paddingTop: 2, fontWeight: 600,fontFamily: 'Poppins', color: "#000" }}>
                                        PERFORMANCE REPORT
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.Course}>
                                <div style={{ height: "20px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "50%", flexDirection: "row", gap: 4, borderRight:"1.5px solid black ", borderLeft:"1.5px solid black" }]}>
                                    <Text style={{ fontSize: 9, marginTop: 5, paddingLeft: 4, color: "#000", fontFamily: 'Poppins',}}>
                                        Name :  
                                    </Text>
                                     <Text style={{ fontSize: 9, marginTop: 5, paddingLeft: 4, color: "#000", fontWeight: 600,fontFamily: 'Poppins',}}>
                                      {item.Student_Name}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "50%", height:"20px" }]}>
                                    <Text style={{ fontSize: 9, marginTop: 5,paddingLeft: 4, marginLeft: 5, color: "#000" ,fontFamily: 'Poppins', }}>
                                        ID No : {item.Student_Code}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.Course}>
                                <div style={{ height: "25px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "50%", flexDirection:"row", gap: 4, borderLeft:"1.5px solid black" }]}>
                                    <Text style={{ fontSize:9, marginTop: 5, paddingLeft: 4, color: "#000", fontFamily: 'Poppins', }}>
                                        Training Programme :
                                    </Text>
                                    <Text
  style={{
    fontSize: 9,
    marginTop: 5,
    paddingLeft: 4,
    fontWeight: 600,
    color: "#000",
    fontFamily: "Poppins",
    flexWrap: "wrap", // ✅ ensures text wraps
    width: "65%", // ✅ gives space to wrap
    wordBreak: "break-word", // ✅ breaks long words if needed
  }}
>
  {item.Course_Name}
</Text>

                                </View>
                                <View style={[styles.tableCol1, { width: "25%",  flexDirection:"row", gap: 4  }]}>
                                    <Text style={{ fontSize: 9, marginTop: 5, marginLeft: 5,paddingLeft: 4, color: "#000", fontFamily: 'Poppins', }}>
                                        Batch No :
                                    </Text>
                                    <Text style={{ fontSize: 9, marginTop: 5, marginLeft: 5,paddingLeft: 4, color: "#000", fontWeight: 600,fontFamily: 'Poppins', }}>
                                       {item.Batch_code}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "25%" }]}>
                                    <Text style={{ fontSize: 9, marginTop: 5, marginLeft: 5, paddingLeft: 4,color: "#000",fontFamily: 'Poppins', }}>
                                        Date : {item.Result_date}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.Course}>
                                <div style={{ height: "40px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "40%", justifyContent:"center", alignItems:"flex-start",borderLeft:"1.5px solid black" }]}>
                                    <Text style={{ fontSize: 8,  paddingLeft: 5, color: "#000", fontWeight: 600,fontFamily: 'Poppins', }}>
                                        Passing Criteria :
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        A+
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        A
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        B+
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        B
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        C
                                    </Text>
                                    <Text style={{ fontSize: 8, marginTop: 2, color: "#000", paddingLeft: "5px" }}>
                                        No certificate
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        90.00% to 100%
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        80.00% to 89.99%{" "}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        70.00% to 79.99%
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        60.00% to 69.99%
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 2,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        50.00% to 59.99%
                                    </Text>
                                    <Text style={{ fontSize: 8, marginTop: 2, color: "#000", paddingLeft: "5px" }}>
                                        49.99 and below{" "}
                                    </Text>
                                </View>
                            </View>
                            <View style={styles.Course}>
                                <div style={{ height: "50px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "100%", borderLeft:"1.5px solid black"  }]}>
                                    <Text style={{ fontSize: 8, paddingLeft:5, color: "#000", fontWeight: 600,fontFamily: 'Poppins',}}>
                                        Brief Description of Training Programme: 
                                    </Text>
                                    <Text style={{ padding: "5px 10px", fontSize: 6.5, color: "#000" }}>
                                        {item.Course_Description}
                                    </Text>
                                </View>
                            </View>

                            <View style={styles.Course}>
                                <div style={{ height: "30px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "5%",borderLeft:"1.5px solid black"  }]}>
                                    <Text style={{ fontSize: 8.5, marginTop: 20, marginLeft: 5, color: "#000" }}>
                                        01{" "}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={{ fontSize: 8.5, marginTop: 40, marginLeft: 5, color: "#000" }}>
                                        Assignments
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "30%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            marginTop: 5,
                                            color: "#000",
                                            paddingLeft: "5px",
                                            borderBottom: "1.5px solid black",
                                        }}
                                    >
                                        {" "}
                                        Total No of Assignments/
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        Assignments Submitted
                                    </Text>

                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        Marks obtained in Assignments
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        Total Marks obtained in Assignments
                                    </Text>
                                    <Text style={{ fontSize: 8.5, marginTop: 5, color: "#000", paddingLeft: "5px", fontWeight: 600,fontFamily: 'Poppins', }}>
                                        Weightage - %
                                    </Text>
                                </View>

                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            height: "15.7px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "10px",
                                            textAlign: "left",
                                        }}
                                    >
                                        {item.Total_Assignments}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            height: "15.7px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "10px",
                                            textAlign: "left",
                                        }}
                                    >
                                        {item.Given_Assignments}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            height: "15.3px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingHorizontal: "10px",
                                            // textAlign: "center",
                                        }}
                                    >
                                        {/* prettier-ignore */}
                                        {item.Ass1_Given || ""}
                                        {"  "}
                                        {item.Ass2_Given || ""}
                                        {"  "}
                                        {item.Ass3_Given || ""}
                                        {"  "}
                                        {item.Ass4_Given || ""}
                                        {"  "}
                                        {item.Ass5_Given || ""}
                                        {"  "}
                                        {item.Ass6_Given || ""}
                                        {"  "}
                                        {item.Ass7_Given || ""}
                                        {"  "}
                                        {item.Ass8_Given || ""}
                                        {"  "}
                                        {item.Ass9_Given || ""}
                                        {"  "}
                                        {item.Ass10_Given || ""}{" "}
                                    </Text>

                                    <Text
                                        style={{
                                            fontSize: 8.5,
                                            height: "15.3px",
                                            paddingTop: 5,
                                            color: "#000",
                                            paddingLeft: "10px",
                                            textAlign: "left",
                                            borderBottom: "1px solid black",
                                        }}
                                    >
                                        {item.Ass1_Given +
                                            item.Ass2_Given +
                                            item.Ass3_Given +
                                            item.Ass4_Given +
                                            item.Ass5_Given +
                                            item.Ass6_Given +
                                            item.Ass7_Given +
                                            item.Ass8_Given +
                                            item.Ass9_Given +
                                            item.Ass10_Given}{" "}
                                        /
                                        {item.Ass1_Max +
                                            item.Ass2_Max +
                                            item.Ass3_Max +
                                            item.Ass4_Max +
                                            item.Ass5_Max +
                                            item.Ass6_Max +
                                            item.Ass7_Max +
                                            item.Ass8_Max +
                                            item.Ass9_Max +
                                            item.Ass10_Max}
                                    </Text>

                                    <View
                                        style={{
                                            width: "100%",
                                            fontSize: 8.5,
                                            paddingTop: 5,
                                            color: "#000",
                                            paddingHorizontal: "10px",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Text>{item.Ass_Percent}</Text>
                                        <Text style={{ marginRight: "22px", fontWeight: 600,fontFamily: 'Poppins',}}>(A)</Text>
                                    </View>
                                </View>
                            </View>

                            <View style={styles.Course}>
                                <div style={{ height: "30px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "5%", borderLeft:"1.5px solid black"  }]}>
                                    <Text style={{ fontSize: 8, marginTop: 40, marginLeft: 5, color: "#000",fontFamily: 'Poppins', }}>
                                        02{" "}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={{ fontSize:8, marginTop: 40, marginLeft: 5, color: "#000",fontFamily: 'Poppins', }}>
                                        Unit Tests
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "30%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            paddingLeft: "5px",
                                            borderBottom: "1px solid black",fontFamily: 'Poppins',
                                        }}
                                    >
                                        Total Unit Test/s
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",fontFamily: 'Poppins',
                                        }}
                                    >
                                        Attended Unit Test/s
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",fontFamily: 'Poppins',
                                        }}
                                    >
                                        Marks obtained in Unit Test/s
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",fontFamily: 'Poppins',
                                        }}
                                    >
                                        Total Marks obtained in Unit Test/s
                                    </Text>
                                    <Text style={{ fontSize: 8, marginTop: 5, color: "#000", paddingLeft: "5px", fontWeight: 600,fontFamily: 'Poppins', }}>
                                        Weightage 35 %
                                    </Text>
                                </View>

                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "18.1px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "10px",
                                            textAlign: "left",fontFamily: 'Poppins',
                                        }}
                                    >
                                        {item.Total_Tests}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "18.1px",
                                            paddingTop: 5,
                                            color: "#000",
                                            paddingLeft: "10px",
                                            borderBottom: "1.5px solid black",
                                            textAlign: "left",fontFamily: 'Poppins',
                                        }}
                                    >
                                        {item.Given_Tests}
                                    </Text>

                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "17.9px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "10px",
                                            textAlign: "left",
                                            fontFamily: 'Poppins',
                                        }}
                                    >
                                        {" "}
                                        {item.Test1_Given || ""} {item.Test2_Given || ""} {item.Test3_Given || ""}{" "}
                                        {item.Test4_Given || ""} {item.Test5_Given || ""} {item.Test6_Given || ""}{" "}
                                        {item.Test7_Given || ""} {item.Test8_Given || ""} {item.Test9_Given || ""}{" "}
                                        {item.Test10_Given || ""}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "17.9px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "10px",
                                            textAlign: "left",
                                            fontFamily: 'Poppins',
                                        }}
                                    >
                                        {item.Test1_Given +
                                            item.Test2_Given +
                                            item.Test3_Given +
                                            item.Test4_Given +
                                            item.Test5_Given +
                                            item.Test6_Given +
                                            item.Test7_Given +
                                            item.Test8_Given +
                                            item.Test9_Given +
                                            item.Test10_Given}{" "}
                                        /{" "}
                                        {item.Test1_Max +
                                            item.Test2_Max +
                                            item.Test3_Max +
                                            item.Test4_Max +
                                            item.Test5_Max +
                                            item.Test6_Max +
                                            item.Test7_Max +
                                            item.Test9_Max +
                                            item.Test10_Max}{" "}
                                    </Text>
                                    <View
                                        style={{
                                            width: "100%",
                                            fontSize: 8,
                                            height: "18.1px",
                                            paddingTop: 4,
                                            paddingLeft: "10px",
                                            color: "#000",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Text style={{top:"5px"}}>{item.Test_Percent}</Text>
                                        <Text style={{ marginRight: "32px", fontSize: 8,fontWeight: 600,fontFamily: 'Poppins',}}>{"(B)"}</Text>
                                    </View>
                                </View>
                            </View>

                            <View style={styles.Course}>
                                <div style={{ height: "30px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "5%", borderLeft:"1.5px solid black"  }]}>
                                    <Text style={{ fontSize: 8, marginTop: 10, marginLeft: 5, color: "#000" }}>
                                        03{" "}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={{ fontSize: 8, marginTop: 10, marginLeft: 5, color: "#000" }}>
                                        Final Examination
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "30%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        Marks obtained{" "}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            paddingLeft: "5px",
                                            fontWeight: 600,
                                            fontFamily: 'Poppins',
                                        }}
                                    >
                                        Weightage -50 %
                                    </Text>
                                </View>

                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "15.1px",
                                            paddingTop: 5,
                                            color: "#000",
                                            borderBottom: "1.5px solid black",
                                            textAlign: "left",
                                            paddingLeft: "10px",
                                        }}
                                    >
                                        {item.Final1_Given}/{item.Final1_Max} {``} {item.Final2_Given} /
                                        {item.Final2_Max} {``} {item.Final3_Given} / {item.Final2_Max}{" "}
                                    </Text>
                                    <View
                                        style={{
                                            width: "100%",
                                            fontSize: 8,
                                            height: "15.1px",
                                            paddingTop: 3,
                                            paddingLeft:"10px",
                                            color: "#000",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Text style={{top:"5px"}}>{item.Final_Percent}</Text>
                                        <Text style={{ marginRight: "30px", fontWeight: 600,fontFamily: 'Poppins', }}>(C)</Text>
                                    </View>
                                </View>
                            </View>

                            <View style={styles.Course}>
                                <div style={{ height: "30px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "5%",borderLeft:"1.5px solid black"  }]}>
                                    <Text style={{ fontSize: 8, marginTop: 30, marginLeft: 5, color: "#000" }}>
                                        04{" "}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={{ fontSize: 8, marginTop: 30, marginLeft: 5, color: "#000" }}>
                                        Attendance Record
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "30%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",
                                        }}
                                    >
                                        Attended Lectures/Total Lectures{" "}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            paddingLeft: "5px",
                                            borderBottom: "1px solid black",
                                        }}
                                    >
                                        Total No of Absent Days
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            paddingLeft: "5px",
                                            borderBottom: "1px solid black",fontWeight: 600,fontFamily: 'Poppins',
                                        }}
                                    >
                                        Attendance %
                                    </Text>
                                    <Text style={{ fontSize: 8, marginTop: 5, color: "#000", paddingLeft: "5px", fontWeight: 600, fontFamily: 'Poppins', }}>
                                        Full Attendance - 0 %
                                    </Text>
                                </View>

                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "14.7px",
                                            paddingTop: 5,
                                            color: "#000",
                                            textAlign: "left",
                                            paddingLeft: "10px",
                                            borderBottom: "1px solid black",
                                        }}
                                    >
                                        {item.AttenLectures}/{item.Total_Lectures}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "14.9px",
                                            paddingTop: 5,
                                            color: "#000",
                                            paddingLeft: "10px",
                                            textAlign: "left",
                                            borderBottom: "1px solid black",
                                        }}
                                    >
                                        {item.Total_Lectures - item.AttenLectures}
                                    </Text>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            height: "18.1px",
                                            paddingTop: 5,
                                            color: "#000",
                                            paddingLeft: "9px",
                                            textAlign: "left",
                                            borderBottom: "1px solid black",
                                        }}
                                    >
                                        {item.Full_Attendance}
                                    </Text>
                                    <View
                                        style={{
                                            width: "100%",
                                            fontSize: 8,
                                           height: "15.7px",
                                            paddingTop: 3,
                                            color: "#000",
                                            paddingHorizontal: "10px",
                                            display: "flex",
                                            flexDirection: "row",
                                            justifyContent: "space-between",
                                        }}
                                    >
                                        <Text style={{top:"5px"}}>0.00</Text>
                                        <Text style={{ marginRight: "20px",fontSize:'8',fontWeight: 600,fontFamily: 'Poppins', }}>{"(D)"}</Text>
                                    </View>
                                </View>
                            </View>

                            <View style={styles.Course}>
                                <div style={{ height: "30px", margin: "0 0 0 0" }}></div>
                                <View style={[styles.tableCol, { width: "5%", borderLeft:"1.5px solid black"  }]}>
                                    <Text style={{ fontSize: 8, marginTop: 5, marginLeft: 5, color: "#000" }}>
                                        05{" "}
                                    </Text>
                                </View>
                                <View style={[styles.tableCol, { width: "20%" }]}>
                                    <Text style={{ fontSize: 8, marginTop: 5, marginLeft: 5, color: "#000" }}>
                                        Final Result
                                    </Text>
                                </View>
                                <View style={[styles.tableCol1, { width: "30%" }]}>
                                    <Text
                                        style={{
                                            fontSize: 8,
                                            marginTop: 5,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "5px",fontWeight: 600,fontFamily: 'Poppins',
                                        }}
                                    >
                                        A + B + C + D
                                    </Text>
                                    <Text style={{ fontSize: 8, marginTop: 5, color: "#000", paddingLeft: "5px",fontWeight: 600,fontFamily: 'Poppins', }}>
                                        Grade
                                    </Text>
                                </View>

                                <View style={[styles.tableCol1, { width: "50%" }]}>
                                    <Text
                                        style={{
                                             fontSize: 8,
                                            height: "18.1px",
                                            paddingTop: 6,
                                            color: "#000",
                                            borderBottom: "1px solid black",
                                            paddingLeft: "8px",
                                            textAlign: "left",
                                        }}
                                    >
                                        {" "}
                                        {item.Final_Result_Percent}
                                    </Text>
                                    <Text
                                        style={{
                                             fontSize: 7.7,
                                            height: "15.7px",
                                            paddingTop: 4,
                                            color: "#000",
                                            paddingLeft: "10px",
                                            textAlign: "left",fontWeight: 600,fontFamily: 'Poppins',
                                        }}
                                    >
                                        {item.Grade}
                                    </Text>
                                </View>
                            </View>
                        </View>
                        <View
                            style={[
                                styles.Course,
                                {
                                    marginTop: "25px",
                                },
                            ]}
                        >
                            <div style={{ height: "20px", margin: "0 0 0 0" }}></div>
                            <View
                                style={[
                                    styles.tableCol,
                                    {
                                        width: "33%",
                                        borderLeft: "1px solid black",
                                        borderTop: "1px solid black",
                                        marginTop: "2px",
                                    },
                                ]}
                            >
                                <Text style={{ fontSize: 9, marginLeft: 5, color: "#000" }}> </Text>
                            </View>
                            <View
                                style={[
                                    styles.tableCol,
                                    { width: "33%", borderTop: "1px solid black", marginTop: "2px" },
                                ]}
                            >
                                <Text style={{ fontSize: 9, marginLeft: 5, color: "#000" }}> </Text>
                            </View>
                            <View
                                style={[
                                    styles.tableCol1,
                                    { width: "33%", borderTop: "1px solid black", marginTop: "2px" },
                                ]}
                            >
                                <Text style={{ fontSize:9, color: "#000" }}> </Text>
                            </View>
                        </View>
                        <View style={styles.Course}>
                            {/* <div style={{ height: "20px", margin: "0 0 0 0" }}>

                            </div> */}
                            <View
                                style={[
                                    styles.tableCol,
                                    { width: "33%", borderLeft: "1px solid black", padding: "2px" },
                                ]}
                            >
                                <Text style={{ fontSize: 9, color: "#000", textAlign: "center" }}>
                                    {item.faculty1.toUpperCase()}
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "33%", padding: "2px" }]}>
                                <Text style={{ fontSize: 9, color: "#000", textAlign: "center" }}>
                                    {item.faculty2.toUpperCase()}
                                </Text>
                            </View>
                            <View style={[styles.tableCol1, { width: "33%", padding: "2px" }]}>
                                <Text style={{ fontSize: 9, color: "#000", textAlign: "center" }}>
                                    {item.approve_by.toUpperCase()}
                                </Text>
                            </View>
                        </View>
                        <View style={styles.Course}>
                            {/* <div style={{ height: "20px", margin: "0 0 0 0" }}>

                            </div> */}
                            <View
                                style={[
                                    styles.tableCol,
                                    { width: "33%", borderLeft: "1px solid black", padding: "2px" },
                                ]}
                            >
                                <Text style={{ fontSize: 9, color: "#000", textAlign: "center", fontWeight: 600,fontFamily: 'Poppins', }}>
                                    {/* {item.Label1}
                                    {``} By */}
                                    Training Coordinator
                                </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "33%", padding: "2px" }]}>
                                <Text style={{ fontSize: 9, color: "#000", textAlign: "center",fontWeight: 600,fontFamily: 'Poppins', }}>
                                    {/* {item.Label2}
                                    {``} By */}
                                    Faculty
                                </Text>
                            </View>
                            <View style={[styles.tableCol1, { width: "33%", padding: "2px" }]}>
                                <Text style={{ fontSize: 9, color: "#000", textAlign: "center",fontWeight: 600,fontFamily: 'Poppins', }}>
                                    Managing Director
                                </Text>
                            </View>
                        </View>
                        <View style={{ width: "100%", marginTop: "5px" }}>
                                                    <Text style={{
                                                        fontSize: 8.5, fontFamily: 'Poppins',
                                                        fontWeight: 600, color: "black"
                                                    }}>F/TD/08/02</Text>
                                                </View>
                    </Page>
                );
            })}
        </Document>
    );
};

export default MyDocument7;
